/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Warren Dowey
 */

export class ComponentActionModel {
  private _componentActionId?: string;
  private _componentActionKey?: string;
  private _componentActionDescription?: string;
  private _sonraiOnly?: boolean;
  private _ownerOnly?: boolean;
  private _actionType?: string;

  constructor(
    componentActionId?: string,
    componentActionKey?: string,
    componentActionDescription?: string,
    sonraiOnly?: boolean,
    ownerOnly?: boolean,
    actionType?: string
  ) {
    this.componentActionId = componentActionId;
    this.componentActionKey = componentActionKey;
    this.componentActionDescription = componentActionDescription;
    this.sonraiOnly = sonraiOnly;
    this.ownerOnly = ownerOnly;
    this.actionType = actionType;
  }

  get componentActionId(): string {
    return this._componentActionId;
  }

  set componentActionId(value: string) {
    this._componentActionId = value;
  }

  get componentActionKey(): string {
    return this._componentActionKey;
  }

  set componentActionKey(value: string) {
    this._componentActionKey = value;
  }

  get componentActionDescription(): string {
    return this._componentActionDescription;
  }

  set componentActionDescription(value: string) {
    this._componentActionDescription = value;
  }

  get sonraiOnly(): boolean {
    return this._sonraiOnly;
  }

  set sonraiOnly(value: boolean) {
    this._sonraiOnly = value;
  }

  get ownerOnly(): boolean {
    return this._ownerOnly;
  }

  set ownerOnly(value: boolean) {
    this._ownerOnly = value;
  }

  public get actionType(): string {
    return this._actionType;
  }

  public set actionType(actionType: string) {
    this._actionType = actionType;
  }

  toJson(): Object {
    const object = {
      component_action_id: this.componentActionId,
      component_action_key: this.componentActionKey,
      component_action_description: this.componentActionDescription,
      sonrai_only: this.sonraiOnly,
      owner_only: this.ownerOnly,
      action_type: this.actionType,
    };
    Object.keys(object).forEach(
      (k) =>
        !object[k] && typeof object[k] !== 'boolean' && object[k] !== undefined && delete object[k]
    );
    return object;
  }

  fromJson(input: any): ComponentActionModel {
    return new ComponentActionModel(
      input['component_action_id'],
      input['component_action_key'],
      input['component_action_description'],
      input['sonrai_only'],
      input['owner_only'],
      input['action_type']
    );
  }
}
